import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ENV } from './env.token';

const isAbsoluteUrl = (url: string): boolean => /^https?:\/\//i.test(url);

export const apiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const environment = inject(ENV);
  const apiUrl = environment.apiBaseUrl;

  // Matches both /api/* (application endpoints) and /health/* (e.g. /health/chatbot,
  // used by the chat widget's health check) — both are routes served by ServerApi.
  const isNotApiUrl = !/^\/?(api|health)/.test(req.url);

  if (!apiUrl || isAbsoluteUrl(req.url) || isNotApiUrl) {
    return next(req);
  }

  const normalizedApiUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
  const normalizedRequestUrl = req.url.startsWith('/') ? req.url : `/${req.url}`;
  const updatedUrl = `${normalizedApiUrl}${normalizedRequestUrl}`;

  return next(req.clone({ url: updatedUrl }));
};
